import BaseApiService from './BaseApiService.js';

class DashboardService extends BaseApiService {
  async getDashboardSummary(orgId) {
    try {
      const endpoint = `/api/admin/dashboard/summary${orgId ? `?orgId=${encodeURIComponent(orgId)}` : ''}`;
      return await this.makeRequest(endpoint, { method: 'GET' });
    } catch (error) {
      console.error('Error fetching dashboard summary:', error);
      throw error;
    }
  }
}

const dashboardService = new DashboardService();
export default dashboardService;
